/* eslint-disable react/prop-types */
import React from 'react';

const ProfileImage = ({ imageUrl }) => (
  <div className="c-profile-image ">
    <img src={imageUrl} alt="profile" />
  </div>
);

export default ProfileImage;
